import React, { useState } from "react";
import { postComment } from "./functions/fetchComments"
import { commentsId } from "./constants";

const commentBackground = (i) => i % 2 === 0 ? "lightsteelblue" : "paleturquoise";


const Comment = ({ body: { text, commentId } }, i) =>
    <div className="row rcorners1" key={commentId}
        style={{ padding: "2em 0 2em 2em", background: commentBackground(i) }}>{text}</div>

const NewComment = ({ setNewCommentsVisible }) => {
    const [user, setUser] = useState("")
    const [message, setMessage] = useState("")

    const submitComment = (user, message, setNewCommentsVisible) => {
        postComment(commentsId, `${user || "anon"} says: ${message}`)
        setNewCommentsVisible(false)
    }

    return (<>
        <h3 style={{ float: "left", paddingLeft: "2em" }}>Your Comment</h3>
        <div className="row" style={{ paddingLeft: "3em" }}>
            <input maxLength={12} placeholder="User Name (optional)" onChange={(e) => setUser(e.target.value)}></input>
        </div>
        <div className="row" style={{ paddingTop: "1em", paddingLeft: "3em" }}>
            <textarea maxLength={240} style={{ borderWidth: "3px", width: "50em" }} placeholder="Your comment (<= 240 chars)"
                onChange={(e) => setMessage(e.target.value)}></textarea>
        </div>
        <div className="row" style={{ paddingTop: "1em", paddingLeft: "3em" }}>
            <input className="button-18" type="button" value="Submit" onClick={() => submitComment(user, message, setNewCommentsVisible)}></input>
        </div>
    </>)
}

const Comments = ({ comments, setCommentsVisible }) => {
    const [newCommentsVisible, setNewCommentsVisible] = useState(true)

    return (<>
        {newCommentsVisible? <NewComment {...{ setNewCommentsVisible }}></NewComment> : "Thank you!"}
        <div className="row">
            <div className="column">
                <h2>Previous Comments</h2>
            </div>
            <div className="column">
                <h2>
                    <input className="button-18" type="button" style={{ backgroundColor:"#cb5050"}} value="Exit" onClick={() => setCommentsVisible(false)}></input></h2>
            </div>
        </div>

        <div className="row">
            {comments.map((comment, i) => Comment(comment, i))}
        </div>
    </>)
}

export default Comments